import objectFromEntries from 'utils/objectFromEntries';
import AllPeoplePanel from './all/allPeoplePanel';
import PeopleInBookPanel from './inBook/peopleInBookPanel';

const personGroups = [
  {
    TabPanel: PeopleInBookPanel,
    id: 'in-book',
    peopleRequired: true,
    title: 'People in Book',
  },
  {
    TabPanel: AllPeoplePanel,
    id: 'all',
    peopleRequired: false,
    title: 'Search Person',
  },
];

export default objectFromEntries(personGroups.map(group => [group.id, group]));
